export default {
  methods: {
    // Дата в формате "12 апреля 2024 г.",
    formatLongDate(newDate) {
      const date = this.getDateToServer(newDate);
      return date.toLocaleString('ru', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    formatDateFile(newDate) {
      newDate = new Date(newDate);
      let date = this.formatServerDate(newDate);
      date = new Date(date);
      let dd = date.getDate();
      if (dd < 10) dd = '0' + dd;
      let mm = date.getMonth() + 1;
      if (mm < 10) mm = '0' + mm;
      let yy = date.getFullYear();
      return `${dd}_${mm}_${yy}`;
    },
    // Количество дней в месяце
    daysInMonth(date) {
      date = this.getDateToServer(date);
      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    },

    // ISO8601 in UTC time zone
    localUTCString(d) {
      let pad = function (n) {
        return n < 10 ? '0' + n : n;
      };
      return d.getFullYear() + '-'
        + pad(d.getMonth() + 1) + '-'
        + pad(d.getDate()) + 'T'
        + pad(d.getHours()) + ':'
        + pad(d.getMinutes()) + ':'
        + pad(d.getSeconds()) + "Z";
    },
    //  ------
    // ISO8601 in Moscow time zone
    localISOString(d) {
      let pad = function (n) {
        return n < 10 ? '0' + n : n;
      };
      return d.getFullYear() + '-'
        + pad(d.getMonth() + 1) + '-'
        + pad(d.getDate()) + 'T'
        + pad(d.getHours()) + ':'
        + pad(d.getMinutes()) + ':'
        + pad(d.getSeconds()) + "+03:00";
    },
    formatServerDate(date) {
      return this.localISOString(date);
    },
    // Дата в формате yyyy-mm-dd
    formatDate(date) {
      let dd = date.getDate();
      if (dd < 10) dd = '0' + dd;
      let mm = date.getMonth() + 1;
      if (mm < 10) mm = '0' + mm;
      let yy = date.getFullYear();
      return yy + '-' + mm + '-' + dd;
    },
    // Время в формате HH:MM
    formatTime(date) {
      let HH = date.getHours();
      if (HH < 10) HH = '0' + HH;
      let MM = date.getMinutes();
      if (MM < 10) MM = '0' + MM;
      return HH + ':' + MM;
    },
    // Дата и время в формате yyyy-mm-dd HH:MM
    formatDateTime(date) {
      const dd = this.formatDate(date);
      const tt = this.formatTime(date);
      return dd + ' ' + tt;
    },

    getDateFromServerString(str) {
      const dd = new Date(str);
      dd.setMinutes(dd.getMinutes() + dd.getTimezoneOffset() + 180);
      return dd;
    },
    getNewDateToServer() {
      const dd = new Date();
      return this.getDateToServer(dd);
    },
    getDateToServer(date) {
      const dd = new Date(date);
      dd.setMinutes(dd.getMinutes() + dd.getTimezoneOffset() + 180);
      return dd;
    },
    formatTableDate(dateStr) {
      if (dateStr == null) {
        return  dateStr;
      }
      const date = this.getDateFromServerString(dateStr);
      let dd = date.getDate();
      if (dd < 10) dd = '0' + dd;
      let mm = date.getMonth() + 1;
      if (mm < 10) mm = '0' + mm;
      let yy = date.getFullYear();
      return dd + '.' + mm + '.' + yy;
    },
    formatTableDateTime(dateStr) {
      const date = this.getDateFromServerString(dateStr);
      return this.formatShortDateTime(date);
    },

    formatServerDateTime(date, timeStr) {
      const dateItem = new Date(date + " " + timeStr);
      const myDate = this.getDateFromServerString(dateItem);
      return this.localISOString(myDate);
    },

    // Дата в формате yyyy-mm-dd
    formatDateOnly(date) {
      return  date.toLocaleDateString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    formatShortDateTime(date) {
      return  date.toLocaleDateString('ru-RU', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    // Новая дата
    newOnlyDate() {
      return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    },
    newPeriodDate() {
      return new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    },
    // Дата полученная с сервера
    dateFromServerString(dateStr) {
      const date = new Date(dateStr)
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    // Строка На сервер из даты
    stringDateToServerFromDate(date) {
      return this.localUTCString(date);
    },
    // Строка На Сервер из строки
    stringDateToServerFormString(dateStr) {
      const date = new Date(dateStr)
      return this.localUTCString(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
    },
    // Строка для инпута из Даты
    stringDateToInputFromDate(date) {
      return this.formatDateOnly(date);
    },
    formattedFromServerDate(date) {
      if (!date) return null;
      return this.formatDate(this.getDateFromServerString(date));
    },
    formattedToServerDate(date) {
      if (!this.dateValidation(date)) return null;
      return this.getDateToServer(date).toISOString();
    },

    testDate() {
      console.log("------- Для работы с датами --------");
      const newPeriodDate = this.newPeriodDate();
      console.log(newPeriodDate);
      // Оправка на сервер
      const toServerDateString = this.stringDateToServerFromDate(newPeriodDate);
      console.log(toServerDateString);
      // Получение с сервера
      const fromServerDate = this.dateFromServerString(toServerDateString)
      console.log(fromServerDate);

      console.log("------ Для работы с Инпутами ---------");
      const newAccruedDate = this.newOnlyDate();
      console.log(newAccruedDate);

      // Строка для Инпута
      const newAccruedDateString = this.stringDateToInputFromDate(newAccruedDate);
      console.log(newAccruedDateString);

      // Оправка на сервер
      const toServerDateString1 = this.stringDateToServerFormString(newAccruedDateString);
      console.log(toServerDateString1);

      // Получение с сервера
      const fromServerDate1 = this.dateFromServerString(toServerDateString1)
      console.log(fromServerDate1);

      // Строка для Инпута
      const newAccruedDateStringFromServer = this.stringDateToInputFromDate(fromServerDate1);
      console.log(newAccruedDateStringFromServer);
    },


  }
}



// WEBPACK FOOTER //
// ./src/utilites/dateFormatter.js